<template>
<DialogFrame :show-dialog="show"
             :on-click-close="close"
             :title="'前払いの申込み'"
             :height="200"
             :width="dialogWidth">
    <template v-slot:dialogContent>
        <transition name="fade">
            <div class="content-frame"
                 v-show="dialogCondition === submitDialogCondition.INPUTTING">
                <div class="container">
                    <div class="row my-2">
                        <div class="col-6">前払可能額</div>
                        <div class="col-6">&yen;{{ amountToString(prepaymentBalance) }}</div>
                    </div>
                    <div class="row my-2">
                        <div class="col-6">申込み金額</div>
                        <div class="col-6 amount-frame">
                            <div v-show="amountToSubmit > 0"
                                 class="amount-zeros">,000</div>
                            <input class=""
                                   type="number"
                                   v-model="amountToSubmit"
                                   :max="Math.round(prepaymentBalance)"
                                   min="1"/>
                        </div>

                    </div>
                    <div class="row justify-content-center my-3">
                        <button class="col-5 btn btn-secondary mx-2"
                                @click="close">キャンセル</button>
                        <button class="col-5 btn btn-success mx-2"
                                :disabled="!canSubmit()"
                                @click="onClickSubmit">申込み</button>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div class="content-frame" v-show="dialogCondition === submitDialogCondition.INQUIRING">
                <div class="container">
                    <div class="row my-2">
                        <div class="col text-center">前払い申請処理中...</div>
                    </div>
                    <div class="row">
                        <div class="col text-center">
                            <div class="spinner-border text-success"
                                 role="status"></div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div class="content-frame" v-show="dialogCondition === submitDialogCondition.SHOW_RESULT">
                <div class="row my-2">
                    <div class="col text-center">{{ resultText }}</div>
                </div>
<!--                <div class="row my-3">-->
<!--                    <div class="col text-start second-text">{{ second }}秒でマイページに戻ります...</div>-->
<!--                </div>-->
                <div class="row my-3 justify-content-center">
                    <button class="col-5 btn btn-success"
                            @click="clickCloseOnResult">閉じる</button>
                </div>
            </div>
        </transition>
    </template>
</DialogFrame>
</template>

<script lang="ts">
import {defineComponent, PropType, ref, watch} from "vue";
import DialogFrame from "@/components/DialogFrame.vue";
import {amountToString} from "@/utils/string-utils";
import {backendApi} from "@/utils/backend-api";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import {FontSizes} from "@/utils/font-sizes";

const submitDialogCondition = {
    INPUTTING: "apply_dialog_condition__inputting",
    INQUIRING: "apply_dialog_condition__inquiring",
    SHOW_RESULT: "apply_dialog_condition__show_result"
}

export default defineComponent({
    name: "SubmitPrepaymentDialog",
    components: {
        DialogFrame,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        close: {
            type: Function as PropType<() => void>,
            required: true
        },
        staffId: {
            type: Number,
            required: true,
        },
        prepaymentBalance: {
            type: Number,
            required: true,
        },
        onFinishSubmitPrepayment: {
            type: Function as PropType<(success: boolean) => void>,
            required: true,
        }
    },
    setup(props) {

        const dialogCondition = ref<string>(""),
            amountToSubmit = ref<number>(0),
            resultText = ref<string>(""),
            second = ref<number>(0),
            dialogWidth = ref<number>(400),
            prepaymentUnit = 1000

        watch(() => props.show, () => {
            if (props.show) {

                const windowWidth = window.innerWidth
                if (windowWidth < 400) {
                    dialogWidth.value = windowWidth - 20
                }

                dialogCondition.value = submitDialogCondition.INPUTTING
            }
        })

        const canSubmit = (): boolean => {
            return amountToSubmit.value * prepaymentUnit <= props.prepaymentBalance
                    && amountToSubmit.value > 0
        }

        let isSubmitSuccessful = false

        const onClickSubmit = async () => {
            dialogCondition.value = submitDialogCondition.INQUIRING

            const resp = await backendApi.makePrepaymentRequest(props.staffId, amountToSubmit.value * prepaymentUnit)
            isSubmitSuccessful = resp.isAuthorized
            if (isSubmitSuccessful) {
                dialogCondition.value = submitDialogCondition.SHOW_RESULT
                resultText.value = `前払い申請が完了しました： ${amountToSubmit.value * prepaymentUnit}円`
                startCountDown()
            } else {
                //
            }
        }

        const clickCloseOnResult = () => {
            props.onFinishSubmitPrepayment(isSubmitSuccessful)
            props.close()
        }

        const startCountDown = () => {
            second.value = 3
            const id = window.setInterval(() => {
                second.value--
                if (second.value <= 0) {
                    window.clearInterval(id)
                    props.onFinishSubmitPrepayment(isSubmitSuccessful)
                    props.close()
                }
            }, 1000)
        }

        // const amountZerosLeft = (): string => {
        //
        //     let amount = amountToSubmit.value
        //     const digitWidth = FontSizes.normalInPx - 4,
        //         indent = 10
        //
        //     if (amount <= 1) {
        //         return (digitWidth + indent) + "px"
        //     } else {
        //         let amountDigits = 0
        //
        //         while (amount >= 1) {
        //             amount /= 10
        //             amountDigits++
        //         }
        //         const amountWidth = digitWidth * amountDigits + 10
        //         return amountWidth + "px"
        //     }
        // }


        return {
            amountToString,
            submitDialogCondition,
            dialogCondition,
            amountToSubmit,
            canSubmit,
            onClickSubmit,
            clickCloseOnResult,
            resultText,
            // second,
            dialogWidth,
            // amountZerosLeft,
        }
    }
})
</script>

<style scoped lang="scss">

.fade-enter-active,
.fade-leave-active {
    /* 表示されている際のCSSはこのブロックに記述 */
    transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
    /* 非表示の際のCSSはこのブロックに記述 */
    opacity: 0;
}

.content-frame {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;

    .amount-frame {
        height: 30px;

        input {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 30px;
            border-radius: 5px;
            border: solid 1px gray;
            background-color: transparent;
            text-indent: 25%;
        }

        .amount-zeros {
            position: absolute;
            height: 30px;
            color: dimgray;
            line-height: 30px;
            left: 50%;
        }
    }

    .spinner-border {
        width: 50px;
        height: 50px;
    }

    .second-text {
        text-indent: 40px;
    }
}



</style>